import { useQuery } from "@tanstack/react-query";
import api from "@/lib/axios";
import { Conversion, PaginatedResponse } from "@/types/api";

export const useConversions = (page = 1, pageSize = 10) => {
  return useQuery({
    queryKey: ["conversions", { page, pageSize }],
    queryFn: async () => {
      const { data } = await api.get<PaginatedResponse<Conversion>>("/conversions/", {
        params: { page, page_size: pageSize },
      });
      return data;
    },
    placeholderData: (prev) => prev,
  });
};
